
define('text!templates/main-photo-text.html',[],function () { return '<a class="b-photo-text js-article-link" href="/articles/<%- slug %>">\n    <span class="b-photo-text__title"><%= title %></span>\n    <div class="b-photo-text__subtitle"><%= category %></div>\n    <div class="b-photo-text__description"><%= description %></div>\n</a>\n';});

